import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import packageJson from '../../package.json';
import { APP_STATUS } from '../appMeta';

const version = packageJson.version;

/**
 * VersionStatusBadge - Displays version and status in the header area
 *
 * Format: v{version} • {status}
 * Example: v0.1.0 • Validation Testing In Progress
 *
 * - Reads version from package.json (single source of truth)
 * - Reads status from appMeta.js (easily configurable)
 * - Links to validation status section in documentation
 * - Muted styling to match header text
 * - Hidden on mobile when space is tight
 */
function VersionStatusBadge() {
    // If no status, just show version
    const displayText = APP_STATUS
        ? `v${version} • ${APP_STATUS}`
        : `v${version}`;

    return (
        <Box
            sx={{
                display: { xs: 'none', sm: 'flex' },
                alignItems: 'center',
                justifyContent: 'center',
                px: 1,
            }}
        >
            <Typography
                component={RouterLink}
                to="/documentation#validation"
                variant="caption"
                sx={{
                    color: 'rgba(255, 255, 255, 0.5)',
                    fontSize: '0.7rem',
                    fontWeight: 400,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: { sm: '180px', md: '280px', lg: 'none' },
                    letterSpacing: '0.02em',
                    textDecoration: 'none',
                    '&:hover': {
                        color: 'rgba(255, 255, 255, 0.7)',
                    },
                }}
            >
                {displayText}
            </Typography>
        </Box>
    );
}

export default VersionStatusBadge;
